import countries from 'i18n-iso-countries';
import enLocale from 'i18n-iso-countries/langs/en.json';
import ltLocale from 'i18n-iso-countries/langs/lt.json';
import ruLocale from 'i18n-iso-countries/langs/ru.json';
import arLocale from 'i18n-iso-countries/langs/ar.json';
import frLocale from 'i18n-iso-countries/langs/fr.json';
import itLocale from 'i18n-iso-countries/langs/it.json';
import jaLocale from 'i18n-iso-countries/langs/ja.json';
import lvLocale from 'i18n-iso-countries/langs/lv.json';
import koLocale from 'i18n-iso-countries/langs/ko.json';
import plLocale from 'i18n-iso-countries/langs/pl.json';
import nlLocale from 'i18n-iso-countries/langs/nl.json';
import etLocale from 'i18n-iso-countries/langs/et.json';
import ukLocale from 'i18n-iso-countries/langs/uk.json';

countries.registerLocale(enLocale);
countries.registerLocale(ltLocale);
countries.registerLocale(ruLocale);
countries.registerLocale(arLocale);
countries.registerLocale(frLocale);
countries.registerLocale(itLocale);
countries.registerLocale(jaLocale);
countries.registerLocale(lvLocale);
countries.registerLocale(koLocale);
countries.registerLocale(plLocale);
countries.registerLocale(nlLocale);
countries.registerLocale(etLocale);
countries.registerLocale(ukLocale);

export default countries;
